var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('vue-paginator',{attrs:{"pagination":_vm.pagination.status,"options":_vm.pagination.options,"callback":_vm.load}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }